import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import SortableTree, { toggleExpandedForAll, getTreeFromFlatData } from 'react-sortable-tree';
import { questionnaire } from '../utils/constants';
import UnfoldMoreIcon from '@material-ui/icons/UnfoldMore';
import UnfoldLessIcon from '@material-ui/icons/UnfoldLess';
import { Button, TextField, InputAdornment, IconButton } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import NavigateBeforeIcon from '@material-ui/icons/NavigateBefore';
import MoreVertIcon from '@material-ui/icons/MoreVert';


import { arrayToTree } from '../utils/functions';

//Redux
import { useDispatch, useSelector } from 'react-redux';
import { getQuestions } from '../redux/actions/admin.actions';


//My Components
import TreeMenu from './TreeMenu';
import SpeedDial from './speedDial';


const alertNodeInfo = ({ node, path, treeIndex }) => {
  const objectString = Object.keys(node)
    .map(k => (k === "children" ? "children: Array" : `${k}: '${node[k]}'`))
    .join(",\n   ");

  global.alert(
    "Info passed to the button generator:\n\n" +
      `node: {\n   ${objectString}\n},\n` +
      `path: [${path.join(", ")}],\n` +
      `treeIndex: ${treeIndex}`
  );
};

const Tree = () => {
    const dispatch = useDispatch();
    const { questions } = useSelector(state => state.data);
    const [treeData, setTreeData] = useState([]);
    const [expand, setExpand] = useState(false);
    const [searchString, setSearchString] = useState('');
    const [searchFocusIndex, setSearchFocusIndex] = useState(-1);
    const [searchFoundCount, setSearchFoundCount] = useState(0);



   const toggleNodeExpansion = expanded => {
    setTreeData(toggleExpandedForAll({ treeData: treeData, expanded }));
    setExpand(!expand)
      };

   const handleChange = treeData => {
      setTreeData(treeData);
   }

 const  selectPrevMatch = () => {
  setSearchFocusIndex(searchFocusIndex !== null
    ? (searchFoundCount + searchFocusIndex - 1) % searchFoundCount
    : searchFoundCount - 1)

  };

  const selectNextMatch = () => {

    setSearchFocusIndex(
        searchFocusIndex !== null
          ? (searchFocusIndex + 1) % searchFoundCount
          : 0
    );
  };




   const handleSearchChange = e => {
     setSearchString(e.target.value)
   }


   const handleGetQuestions = async () => {

    await dispatch(getQuestions())
    .then(rs => {
      
    })
    .catch(err => {
      console.log(err)
    })

   }



   useEffect(() => {
      handleGetQuestions()
   }, [])

   useEffect(() => {
    if(questions.length !== 0){
      let rs = arrayToTree(questions);
      if(treeData.length !== 0){
        setTreeData(toggleExpandedForAll({ treeData: rs, expanded: true }));
        setExpand(true);
      } else {
        setTreeData(rs);
      }
    }
 }, [questions])



    return (
        <div style={{ height: 400 }}>
          <div className="d-flex">
      <TextField
              id="input-with-icon-textfield"
              size="small"
              onChange={handleSearchChange}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
                endAdornment: (
                  <InputAdornment position="start">
                   {searchFocusIndex} / {searchFoundCount}
                  </InputAdornment>
                )
              }}
            />  
            <IconButton className="m-1" 
              onClick={selectPrevMatch}
                ><NavigateBeforeIcon color="primary"/>
                </IconButton> 
            <IconButton className="m-1" 
             onClick={selectNextMatch}
            >
              <NavigateNextIcon color="primary"/>
              </IconButton>
              {/* <IconButton className="m-1 ml-2" 
             onClick={() => toggleNodeExpansion(!expand)}
            >
             {expand ? <UnfoldLessIcon color="primary"  /> : <UnfoldMoreIcon color="primary" />}
              </IconButton> */}
      {/* <Button variant="contained" className="ml-auto" size="small" onClick={() => toggleNodeExpansion(!expand)}>{expand ? 'Collapse' : 'Expand'} &nbsp;{expand ? <UnfoldLessIcon fontSize="small" /> : <UnfoldMoreIcon fontSize="small"/>}</Button> */}

            </div>
          
            <br/><br/>

        <SortableTree
                canDrop={({ nextParent, node, treeIndex, nextTreeIndex, prevTreeIndex, prevParent }) =>  { 
                  console.log(nextParent)
                  console.log(prevParent)

                  if(nextParent){
                    let ln = nextParent.children.length === 1;
                    let ind = nextParent.children.find(a => a.id === node.id);
                    return  nextParent['type'] === 'choice' && ind && ln;
                  } else {
                    return true
                  }
                }}
         searchQuery={searchString}
         searchFocusOffset={searchFocusIndex}
         className="tree-wrapper"
          treeData={treeData}
          onChange={handleChange}
          isVirtualized={false}
          canDrag={(node) => node.node["type"] !== "choice"}
          style={{fontSize: '13px'}}
          searchFinishCallback={matches => {
           
            setSearchFoundCount(matches.length)
            setSearchFocusIndex(matches.length > 0 ? searchFocusIndex % matches.length : 0)
          }}
          onMoveNode={({ node, treeIndex, path }) =>
              console.log(
                "node:",
                node,
                "treeIndex:",
                treeIndex,
                "path:",
                path
              )
            }
          generateNodeProps={rowInfo => ({
            buttons: [
            //   <IconButton className="m-1" 
            //        style={{
            //       verticalAlign: "middle"
            //     }}
            //  >
            //    <MoreVertIcon color="primary"/>
            //    </IconButton>
            <TreeMenu vals={rowInfo.node} />
              // <button
              //   className="btn btn-outline-success"
              //   style={{
              //     verticalAlign: "middle"
              //   }}
              //   onClick={() => alertNodeInfo(rowInfo)}
              // >
              //   ℹ
              // </button>
            ]
          })}
        />
        <SpeedDial expand={expand} handleExpand={toggleNodeExpansion}/>
        </div>
    );
}

export default Tree